import React from 'react';

interface IconProps {
  customClass?: string;
}

export const SearchIcon: React.FC<IconProps> = ({ customClass }) => (
  <svg viewBox="0 0 32 32" className={`icon ${customClass || ''}`}>
    <title>ico-search</title>
    <path
      d="M23.429 14.654a8.818 8.818 0 0 1-8.822 8.821 8.818 8.818 0 0 1-8.821-8.821 8.818 8.818 0 0 1 8.821-8.822 8.818 8.818 0 0 1 8.822 8.822m.278 7.103c1.625-2.09 2.507-4.596 2.507-7.15C26.214 8.2 21.014 3 14.607 3 8.2 3 3 8.2 3 14.607c0 6.407 5.2 11.607 11.607 11.607 2.6 0 5.154-.882 7.15-2.507l4.029 4.029a1 1 0 0 0 1.414 0l.536-.536a1 1 0 0 0 0-1.414l-4.029-4.029z"
      fill="#00334D"
      fillRule="evenodd"
    />
  </svg>
);
